{
  "title": "Crown of Stars",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "7th-level evocation",
  "level": 7,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "1 hour",
  "description": [
    "Seven star-like motes of light appear and orbit your head until the spell ends. You can use a bonus action to send one of the motes streaking toward one creature or object within 120 feet of you. When you do so, make a ranged spell attack. On a hit, the target takes 4d12 radiant damage. Whether you hit or miss, the mote is expended. The spell ends early if you expend the last mote. If you have four or more motes remaining, they shed bright light in a 30-foot radius and dim light for an additional 30 feet. If you have one to three motes remaining, they shed dim light in a 30-foot radius.",
    "At Higher Levels. When you cast this spell using a spell slot of 8th level or higher, the number of motes created increases by two for each slot level above 7th."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
